<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Halaman ini hanya digunakan untuk menggabungkan transaksi dari
          bank yang tidak valid ke bank yang valid. Setelah transaksi
          digabungkan, bank yang tidak valid akan terhapus.</FormNote
        >

        <FormRow class="mb-4" :required="true">
          <template #label>From Bank</template>
          <template #field>
            <multiselect
              v-model="formData.from"
              :options="listMemberBankFrom"
              :loading="listMemberBankFromLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :searchable="false"
              :class="$v.formData.from.$error ? 'multiselect--error' : ''"
              track-by="id"
              label="tooltip"
              tag-placeholder="Press enter to choose"
              placeholder="Choose member bank"
              :deselectLabel="''"
              @input="getListMemberBankTo"
            >
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.from.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.from.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>To Bank</template>
          <template #field>
            <multiselect
              v-model="formData.to"
              :options="listMemberBankTo"
              :loading="listMemberBankToLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :searchable="false"
              :class="$v.formData.to.$error ? 'multiselect--error' : ''"
              track-by="id"
              label="tooltip"
              tag-placeholder="Press enter to choose"
              placeholder="Choose member bank"
              :deselectLabel="''"
            >
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.to.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.to.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Reason for Merge</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Reason for Update"
              rows="5"
              v-model="formData.reason"
            ></textarea>
            <div
              class="form-error"
              v-if="$v.formData.reason.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.reason.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>
      </template>

      <template #footer>
        <FormRow class="mb-0">
          <template #field>
            <BaseButton type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div class="ml-4">
              or
              <router-link :to="{ name: 'MemberList' }" class="link ml-2"
                >Back to List Members</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>

<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  mixins: [submitFormMixin],
  components: {
    Multiselect,
  },
  validations: {
    formData: {
      from: {
        required,
      },
      to: {
        required,
      },
      reason: {
        required,
      },
    },
  },
  data: () => {
    return {
      listMemberBankFrom: [],
      listMemberBankFromLoading: true,

      listMemberBankTo: [],
      listMemberBankToLoading: false,

      formData: {
        from: null,
        to: null,
        reason: ""
      },
    };
  },
  created() {
    this.getListMemberBankFrom();
  },
  watch: {
    "$route.params.id": function (id) {
      if (id) {
        this.fetchData(id);
        this.formCreate = false;
      } else {
        this.formCreate = true;
      }
    },
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint(this.$route)
        : "/" +
            this.$route.meta.endpoint(this.$route) +
            "/" +
            this.formData.uuid;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint(this.$route);
    },
  },
  methods: {
    getListMemberBankFrom() {
      this.listMemberBankFrom = [];
      this.listMemberBankFromLoading = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/member/" + this.$route.params.memberId + "/bank-account"
        )
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listMemberBankFrom = response.data;
            }
          }
        })
        .finally(() => {
          this.listMemberBankFromLoading = false;
        });
    },
    getListMemberBankTo() {
      delete this.formData.to;
      this.listMemberBankTo = [];
      this.listMemberBankToLoading = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/member/" + this.$route.params.memberId + "/bank-account?exclude_uuid=" + this.formData.from.uuid
        )
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listMemberBankTo = response.data;
            }
          }
        })
        .finally(() => {
          this.listMemberBankToLoading = false;
        });
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        this.$http({
          method: "patch",
          url: process.env.VUE_APP_API_URL + this.submitUrl + '/merge',
          data: this.formData,
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push(
                {
                  name: "MemberProfile",
                  params: { memberId: this.$route.params.memberId },
                },
                () => {
                  this.$swal({
                    position: "bottom-end",
                    showConfirmButton: false,
                    toast: true,
                    timer: 5000,
                    timerProgressBar: true,
                    title: res.data.message,
                    icon: "success",
                  });
                }
              );
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                this.updateMsg = error.response.data.data.member_bank_account;

                this.formSubmitted = false;
                this.formLoading = false;
                this.formData.force_update = 1;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
  },
};
</script>
